import { FC } from "react";

import { Col, Row, Skeleton } from "@ctra/components";
import { classname } from "@ctra/utils";

import {
  useInsight,
  InsightValidation,
  AjinomotoHighRiskCowsInsight,
  AjinomotoHighRiskCowList
} from "@insights";

import baseStyles from "../InsightBody/InsightBody.module.less";

/**
 * High risk cows insight body
 * @return {React.ReactNode}
 * @constructor
 */
export const AjinomotoHighRiskCowsInsightBody: FC = () => {
  const {
    meta: { isLoading }
  } = useInsight<AjinomotoHighRiskCowsInsight>();

  return (
    <Skeleton active loading={isLoading}>
      <Row className={classname(baseStyles.Row, baseStyles.Padded, baseStyles.Gray)}>
        <Col flex={1}>
          <AjinomotoHighRiskCowList />
        </Col>
      </Row>
      <Row className={classname(baseStyles.Row, baseStyles.Padded, baseStyles.LastRow)}>
        <Col flex={1}>
          <InsightValidation />
        </Col>
      </Row>
    </Skeleton>
  );
};
